import React, { useEffect, useCallback, useState} from 'react';
import ethereum from 'decentralized/ethereum.js';
import {connect} from 'react-redux';

const Rating = ({content, color, type}) => { 
    const [rating, setRating] = useState(undefined);
    let list = [0, 1, 2, 3, 4];
    const onClick = useCallback((r) => {
        setRating(r);
        ethereum.xanadu.rateSound(content, r, type);
    }, [setRating, content]);

    useEffect(() => {
        ethereum.xanadu.getSoundRating(content, type)
            .then(x => {
                setRating(x);
            });
    }, [setRating, content]);

    return (
        <div className="rating">
          {list.map(
              x =>
                  <Star
                    color={color}
                    onClick={onClick}
                    number={x}
                    rating={rating}/>)}
       </div>
    );
}

const Star = ({number, rating, onClick, color}) => {

    let className = "star";
    if (number <= rating) {
        className += " starred";
    }

    let style = {
        color: color
    };

    return (
        <div
          style={style}
          onClick={() => onClick(number)}
          className={className}>
          <span>&#9734;</span>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Rating);
